import { render, staticRenderFns } from "./clinicalnoteCertificateSubMenu.vue?vue&type=template&id=1c3cd86a&"
import script from "./clinicalnoteCertificateSubMenu.vue?vue&type=script&lang=js&"
export * from "./clinicalnoteCertificateSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./clinicalnoteCertificateSubMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3cd86a')) {
      api.createRecord('1c3cd86a', component.options)
    } else {
      api.reload('1c3cd86a', component.options)
    }
    module.hot.accept("./clinicalnoteCertificateSubMenu.vue?vue&type=template&id=1c3cd86a&", function () {
      api.rerender('1c3cd86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navmenu/clinicalnoteCertificateSubMenu.vue"
export default component.exports